<style lang="less">
.links {
  .filters {
    margin-bottom: 1em;
    display: flex;

    .tip {
      font-size: .86em;
      margin: 0 1.2em .6em 0;
      flex-shrink: 0;
      width: 1.7em;
      height: 1.7em;
      background: url(/static/filter.svg) no-repeat center / contain;
    }

    .tags {
      display: flex;
      flex-wrap: wrap;
    }

    .item {
      margin: 0 .8em .6em 0;
      padding: 0 .3em 0 1.4em;
      line-height: 1.5;
      border: 1px dotted #8d6c9f;
      background: #f9e3ae no-repeat left .25em center / auto 70%;
      text-transform: capitalize;
      font-size: .9em;
      font-weight: 100;
      color: rgba(44, 62, 80, 0.88);

      &.name {
        background-image: url(/static/text.svg);
      }
      &.tag {
        background-image: url(/static/price-tag.svg);
      }

      .close {
        margin: 0.2em 0 0 0.3em;
        float: right;
        width: 1em;
        height: 1em;
        background: url(/static/close-window.svg) no-repeat center / contain;
      }
    }
  }

  .items {
    overflow: hidden;
  }

  .wrapper {
    display: flex;
    flex-wrap: wrap;
    margin: -1px 0 0 -1px;

    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }

  .link {
    width: 120px;
    float: left;
    box-sizing: border-box;
    border-top: 1px solid #d5d5d5;
    border-left: 1px solid #d5d5d5;

    .item {
      width: 100%;
      padding-bottom: 100%;
      position: relative;
    }

    a {
      position: absolute;
      top: 1.2em;
      right: 1.2em;
      bottom: 1.2em;
      left: 1.2em;
      color: inherit;
      text-decoration: none;
    }

    .icon {
      width: 80%;
      padding-bottom: 80%;
      background: no-repeat center / contain;
      margin: 0 auto;
    }

    .name {
      margin-top: .15em;
      font-size: .85em;
      text-align: center;
      color: rgba(44, 62, 80, 0.8);
    }
  }

  /////////////////////////////////

  .link {
    .item {
      .icon {
        transition: transform 300ms;
      }
      &:hover {
        .icon {
          transform: scale(1.1);
        }
      }
    }
  }

  @media (max-width: 800px) {
    .filters {
      justify-content: center;
    }
  }
}
</style>

<template>
<div class="links">
  <div class="filters" v-if="filters.name || filters.tags.length">
    <div class="tip"></div>
    <div class="tags">
      <div class="item name" v-if="filters.name">
        <span>{{ filters.name }}</span>
        <span class="close" @click="handleFilterClear('name')"></span>
      </div>
      <div class="item tag" v-for="(tag, i) in filters.tags" :key="i">
        <span>{{ tag }}</span>
        <span class="close" @click="handleFilterClear('tag', tag)"></span>
      </div>
    </div>
  </div>
  <div class="items">
    <div class="wrapper" ref="container">
      <div v-for="link in filteredLinks" :key="link.name" :class="{
          link: true,
          ['link-' + link.name.toLowerCase()]: true
        }" :style="{
          width: itemWidth + 'px'
        }">
        <div class="item">
          <a :href="link.href" :target="link.href.indexOf('http') === 0 ? '_blank' : '_self'">
            <div class="icon" :style="{
              'background-image': `url(${staticDir + link.icon})`
            }"></div>
            <div class="name">{{ link.name }}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {staticDir, links} from '../data'

const itemBasis = 120

export default {
  name: 'Links',
  data () {
    return {
      staticDir,
      links,
      clientWidth: 0,
      filters: {
        name: '',
        tags: []
      }
    }
  },
  computed: {
    itemWidth() {
      let count = Math.floor(this.clientWidth / itemBasis)
      return Math.floor(this.clientWidth / count)
    },
    filteredLinks() {
      let {name, tags} = this.filters
      if (!name && !tags.length) {
        return this.links
      }
      return this.links.filter(function (link) {
        return (!name || link.name.toLowerCase().indexOf(name) >= 0)
          && (!tags.length || link.tags.some(function (tag) {
            return tags.includes(tag)
          }))
      })
    }
  },
  methods: {
    updateClientWidth() {
      this.clientWidth = this.$refs.container.clientWidth
    },
    handleFilterClear(type, value) {
      let {name, tags} = this.filters

      switch (type) {
        case 'name':
          name = ''
          break
        case 'tag':
          tags = tags.filter(function (tag) {
            return tag !== value
          })
          break
      }

      let query = {}
      if (name) {
        query.name = name
      }
      if (tags.length) {
        query.tags = tags.join(',')
      }

      this.$router.replace({query})
    }
  },
  mounted() {
    this.updateClientWidth()
    this.handleWindowResize = () => {
      this.updateClientWidth()
    }
    window.addEventListener('resize', this.handleWindowResize, false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      Object.assign(vm.filters, parseFilterQuery(to.query))
    })
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.filters, parseFilterQuery(to.query))
    next()
  }
}

function parseFilterQuery({name, tags}) {
  name = name ? name.toLowerCase().trim() : ''
  tags = tags ? tags.split(',').map(function (tag) {
    return tag.toLowerCase().trim()
  }).filter(function (tag) {
    return !!tag
  }) : []
  return {name, tags}
}
</script>



// WEBPACK FOOTER //
// Links.vue?088645dd